import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-equties',
  templateUrl: './equties.component.html',
  styleUrls: ['./equties.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EqutiesComponent implements OnInit {
  // balanceInProgress = false;
  // accountFinBalances = null;
  // constructor(private cdRef: ChangeDetectorRef,
  //             private accountService: AccountService) { }
  //
  // async ngOnInit() {
  //   await this.getAccountFinBalances();
  // }
  //
  // async getAccountFinBalances(profileId?) {
  //   try {
  //     this.balanceInProgress = true;
  //     let accountFinBalances = await this.accountService.getAccountFinBalances(profileId);
  //     this.accountFinBalances = accountFinBalances[0];
  //     console.log(this.accountFinBalances)
  //     this.balanceInProgress = false;
  //     this.cdRef.detectChanges();
  //   } catch (e) {
  //     this.balanceInProgress = false;
  //     this.cdRef.detectChanges();
  //   }
  // }

  currentUser;
  balanceInProgress = false;
  calsBalancesDetails = [];

  constructor(
    private accountService: AccountService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService
  ) { }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    await this.getCalsBalances();
    this.cdRef.detectChanges();
  }

  async getCalsBalances() {
    try {
      this.balanceInProgress = true;
      this.cdRef.detectChanges();
      for (let acc = 0; acc < this.currentUser.investorCodeDetails.length; acc++) {
        let s = await this.accountService.getAccountFinBalances(this.currentUser.investorCodeDetails[acc].customerCode);
        this.calsBalancesDetails.push(s[0]);
      }
      console.log(this.calsBalancesDetails)
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    }
  }

}
